import { map as _map } from 'lodash';
import { find as _find } from 'lodash';
import { differenceBy as _differenceBy } from 'lodash';

class VehicleDetailsController {
  constructor(lookupService, authService) {
    "ngInject";

    this.lookupService = lookupService;
    this.authService = authService;

    this.initializeLookups();

    this.panels = {
      extras: true
    };

    this.editLoad = false;

    this.defaultExtrasList = []
  }

  initializeLookups() {
    const ctrl = this;

    this.lookupService.lookupAccessoryLookups(this.authService.authData.currentLocation.key)
      .then(accessoryLookups => {
        ctrl.accessoryLookups = accessoryLookups;

        ctrl.vehicle.extras = _map(ctrl.defaultExtrasList, item => {
          return {
            key: item.key,
            value: ''
          };
        });

        ctrl.vehicle.accessories = _map(ctrl.accessoryLookups, item => {
          return {
            accessoryLookupId: item.accessoryLookupId,
            name: item.name,
            enabled: false
          }
        });
      });
  }

  $doCheck() {
    const ctrl = this;

    if (!ctrl.editLoad && ctrl.vehicle && ctrl.vehicle.vehicleId) {
      let editAccessories = ctrl.vehicle.accessories;
      let newAccessories = _map(ctrl.accessoryLookups, item => {
        const matchingAccessory = _find(editAccessories, o => o.accessoryLookupId === item.accessoryLookupId);
        const enabled = (matchingAccessory) ? matchingAccessory.enabled : false;

        return {
          accessoryLookupId: item.accessoryLookupId,
          name: item.name,
          enabled: enabled
        };
      });
      ctrl.vehicle.accessories = newAccessories;

      const missingElements = _differenceBy(this.defaultExtrasList, this.vehicle.extras, 'key');
      missingElements.map(item => {
        ctrl.vehicle.extras.push({
          key: item.key,
          value:''
        });
      });

      this.editLoad = true;
    }
  }

  addField() {
    if (this.tempField)
    {
      this.vehicle.extras.push({key: this.tempField, value: ''});
      this.tempField = '';
    }
  }
}

export default VehicleDetailsController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleDetails/vehicleDetails.controller.js